import type { App } from "vue";
import * as Sentry from "@sentry/vue";
import { getSession } from "@/services/auth";

export const sentry = {
  install: (app: App) => {
    const SENTRY_DSN = import.meta.env.VITE_SENTRY_DSN;
    const session = getSession();

    if (SENTRY_DSN) {
      Sentry.init({
        app,
        dsn: SENTRY_DSN,
        enableLogs: !import.meta.env.PROD,
        debug: !import.meta.env.PROD,
        environment: import.meta.env.MODE,
        release: import.meta.env.VITE_APP_SENTRY_RELEASE,
        initialScope: {
          user: {
            email: session?.email,
            username: session?.name,
            id: session?.id,
          }
        }
      });
    }
  }
}
